import React, { Component } from 'react';
import ReactHighcharts from '../CommonComponents/Highcharts';
import { Text } from '../CommonComponents/OPL/Text/Text';
export default class MonteCarloChartView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: null,
    };
  }

  style(color) {
    return {
      background: color,
    };
  }

  render() {
    const {
      clientId,
      chartData,
      isPrint,
      expanded,
      showDetails,
      breakdownArray,
      index,
      firstYear,
      lastYear,
      year,
      toggleExpanded,
      navigateYears,
      toggleShowDetails,
      isCanadian,
    } = this.props;

    const LEGEND = [
      ...(isCanadian ? [] : ['Social Security']),
      'Pension',
      'Annuities',
      'Distributions',
      'Other Incomes',
    ];

    if (!chartData) {
      return null;
    }
    return (
      <section
        className={`RetirementIncomeChart${isPrint ? ' is-print' : ''}${
          expanded ? ' expanded' : ''
        }`}
      >
        <Text
          fontSize="h6"
          color="info.500"
          display="inline-block"
          width="50%"
          style={{ lineHeight: '80px' }}
        >
          Retirement Income
        </Text>
        {isPrint && (
          <ul className="legend">
            {LEGEND.map((item, index) => (
              <li>
                <i style={this.style(ADV.settings.retirement_income_colors[index])}></i>
                {item}
              </li>
            ))}
          </ul>
        )}
        <div className="flex-wrap">
          <div className="chart_container">
            <ReactHighcharts
              autoResize={true}
              container="RetirementIncomeBarChartContainer"
              options={chartData}
            />
          </div>
          <div className="breakdown_detail">
            <div className="pull_tab" onClick={toggleExpanded(expanded, clientId)}>
              <i className="fa fa-sign-out-alt"></i>
            </div>
            <div className="wrapper">
              <div className={`content${showDetails ? ' detail_shown' : ''}`}>
                <Text fontSize="h5" fontWeight={600} pt={20} pr={12}>
                  Monthly Income Detail
                  <Text display="block" fontSize="h3" color="success.600" fontWeight={600}>
                    {year}
                  </Text>
                </Text>
                <div className="controls">
                  <a
                    className={`btn prev${firstYear ? ' hide' : ''}`}
                    onClick={navigateYears(index, -1, clientId)}
                  ></a>
                  <a
                    className={`btn next${lastYear ? ' hide' : ''}`}
                    onClick={navigateYears(index, 1, clientId)}
                  ></a>
                </div>
                <a className="show_detail" onClick={toggleShowDetails(showDetails, clientId)}>
                  {showDetails ? 'Hide Detail' : 'Show Detail'}
                </a>
                <ul>
                  {breakdownArray.map(breakdown => {
                    return (
                      <li className={breakdown.classes}>
                        <i></i>
                        {breakdown.name}
                        <span className="amount">{breakdown.amount}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
